/**
 * VK Overflow Menu - Dropdown Panel
 * Shows overflow items in a styled panel when "More" is clicked
 * Dynamically updates when viewport changes
 */
(function() {
  'use strict';

  let panel = null;
  let moreButton = null;

  function updatePanelItems() {
    if (!panel) return;

    // Clear existing items
    panel.innerHTML = '';

    // Find ALL current overflow items
    const overflowItems = document.querySelectorAll('.menu-list__list-item[slot="overflow"]');
    
    overflowItems.forEach(item => {
      const link = item.querySelector('a.menu-list__link');
      if (link) {
        const clonedLink = link.cloneNode(true);
        clonedLink.className = 'vk-overflow-panel__link';
        panel.appendChild(clonedLink);
      }
    });

    console.log('VK: Panel updated with', overflowItems.length, 'items');
  }

  function createOverflowPanel() {
    // Find the "More" button
    moreButton = document.querySelector('.menu-list__list-item[slot="more"] > button');
    if (!moreButton) {
      return;
    }

    // Check if panel already exists
    if (document.querySelector('.vk-overflow-panel')) {
      panel = document.querySelector('.vk-overflow-panel');
      updatePanelItems();
      return;
    }

    // Create the dropdown panel
    panel = document.createElement('div');
    panel.className = 'vk-overflow-panel';
    panel.style.display = 'none';

    // Find the header to insert panel after
    const headerGroup = document.querySelector('#header-group') ||
                        document.querySelector('.shopify-section-group-header-group');
    
    if (headerGroup) {
      headerGroup.appendChild(panel);
    } else {
      const header = document.querySelector('.header-section') || 
                     document.querySelector('header-component') ||
                     document.querySelector('header');
      if (header) {
        header.parentNode.insertBefore(panel, header.nextSibling);
      }
    }

    // Populate with items
    updatePanelItems();

    // Toggle panel on More button click
    moreButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Update items before showing
      updatePanelItems();
      
      if (panel.style.display === 'none') {
        panel.style.display = 'flex';
        moreButton.setAttribute('aria-expanded', 'true');
      } else {
        panel.style.display = 'none';
        moreButton.setAttribute('aria-expanded', 'false');
      }
    });

    // Close panel when clicking outside
    document.addEventListener('click', function(e) {
      if (panel && panel.style.display !== 'none') {
        if (!panel.contains(e.target) && !moreButton.contains(e.target)) {
          panel.style.display = 'none';
          moreButton.setAttribute('aria-expanded', 'false');
        }
      }
    });

    // Close panel on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && panel && panel.style.display !== 'none') {
        panel.style.display = 'none';
        moreButton.setAttribute('aria-expanded', 'false');
      }
    });

    // Update panel when window resizes
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        updatePanelItems();
        if (panel) {
          panel.style.display = 'none';
          if (moreButton) moreButton.setAttribute('aria-expanded', 'false');
        }
      }, 250);
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createOverflowPanel);
  } else {
    createOverflowPanel();
  }

  // Retry after delays
  setTimeout(createOverflowPanel, 500);
  setTimeout(createOverflowPanel, 1500);
  setTimeout(createOverflowPanel, 3000);

})();